import { Card } from "@fanduel/og-fe-library";
import { Icon } from "@fanduel/og-fe-library";
import Image from "next/image";
import Link from "next/link";
import { AUTHOR_TALENT_LINK_CLICKED } from "@/constants/amplitude";
import { ContentAuthor } from "@/graphql/gql/graphql";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import Styles from "./authorList.module.scss";

interface AuthorsListProps {
  authors: ContentAuthor[];
  pageAuthorName: string;
}

const AuthorsList = ({ pageAuthorName, authors }: AuthorsListProps) => {
  const { logAmplitudeEvent } = useAmplitude();

  const handleAuthorTracking = (author: ContentAuthor) => {
    logAmplitudeEvent(AUTHOR_TALENT_LINK_CLICKED, {
      Author: pageAuthorName,
      "Link Text": author.name,
      Module: "explore_our_talent",
      "Link URL": `/author/${author.slug}`,
    });
  };

  return (
    <Card className={Styles.card} variant="elevation">
      <h2 className={Styles.title}>
        <Icon
          iconName="icons.trophy"
          iconSize={17}
          iconColor="colorBaseBlack"
        />
        Explore our talent
      </h2>
      <div className={Styles.authorsList}>
        {authors &&
          authors.map((author) => (
            <div key={author.id} className={Styles.authorItem}>
              {author.profileImageUrl && (
                <div className={Styles.authorImage}>
                  <Image
                    src={author.profileImageUrl ?? ""}
                    alt={`${author.name}'s profile picture`}
                    width={42}
                    height={42}
                    className={Styles.image}
                  />
                </div>
              )}
              <div className={Styles.authorInfo}>
                <Link
                  href={`/author/${author.slug}`}
                  passHref
                  onClick={() => {
                    handleAuthorTracking(author);
                  }}
                >
                  <span className={Styles.authorName}>{author.name}</span>
                </Link>
              </div>
            </div>
          ))}
      </div>
    </Card>
  );
};

export default AuthorsList;
